
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1gfe1_7b6p8_9"
};
  